module.exports = __webpack_public_path__ + "static/media/Close.a5f216dd.svg";